const regionByDepartement = {
  1: "Rhône-Alpes",
  2: "Picardie",
  3: "Auvergne",
  4: "Provence-Alpes-Côte-d'Azur",
  5: "Provence-Alpes-Côte-d'Azur",
  6: "Provence-Alpes-Côte-d'Azur",
  7: "Rhône-Alpes",
  8: "Champagne-Ardenne",
  9: "Midi-Pyrénées",
  10: "Champagne-Ardenne",
  11: "Languedoc-Roussillon",
  12: "Midi-Pyrénées",
  13: "Provence-Alpes-Côte-d'Azur",
  14: "Basse-Normandie",
  15: "Auvergne",
  16: "Poitou-Charentes",
  17: "Poitou-Charentes",
  18: "Centre",
  19: "Limousin",
  20: "Corse",
  21: "Bourgogne",
  22: "Bretagne",
  23: "Limousin",
  24: "Aquitaine",
  25: "Franche-Comté",
  26: "Rhône-Alpes",
  27: "Haute-Normandie",
  28: "Centre",
  29: "Bretagne",
  30: "Languedoc-Roussillon",
  31: "Midi-Pyrénées",
  32: "Aquitaine",
  33: "Aquitaine",
  34: "Languedoc-Roussillon",
  35: "Bretagne",
  36: "Centre",
  37: "Centre",
  38: "Rhône-Alpes",
  39: "Franche-Comté",
  40: "Aquitaine",
  41: "Centre",
  42: "Rhône-Alpes",
  43: "Auvergne",
  44: "Pays-de-la-Loire",
  45: "Centre",
  46: "Midi-Pyrénées",
  47: "Aquitaine",
  48: "Languedoc-Roussillon",
  49: "Pays-de-la-Loire",
  50: "Basse-Normandie",
  51: "Champagne-Ardenne",
  52: "Champagne-Ardenne",
  53: "Pays-de-la-Loire",
  54: "Lorraine",
  55: "Lorraine",
  56: "Bretagne",
  57: "Lorraine",
  58: "Bourgogne",
  59: "Nord-Pas-de-Calais",
  60: "Picardie",
  61: "Basse-Normandie",
  62: "Nord-Pas-de-Calais",
  63: "Auvergne",
  64: "Aquitaine",
  65: "Midi-Pyrénées",
  66: "Languedoc-Roussillon",
  67: "Alsace",
  68: "Alsace",
  69: "Rhône-Alpes",
  70: "Franche-Comté",
  71: "Bourgogne",
  72: "Pays-de-la-Loire",
  73: "Rhône-Alpes",
  74: "Rhône-Alpes",
  75: "Île-de-France",
  76: "Haute-Normandie",
  77: "Île-de-France",
  78: "Île-de-France",
  79: "Poitou-Charentes",
  80: "Picardie",
  81: "Midi-Pyrénées",
  82: "Midi-Pyrénées",
  83: "Provence-Alpes-Côte-d'Azur",
  84: "Provence-Alpes-Côte-d'Azur",
  85: "Pays-de-la-Loire",
  86: "Poitou-Charentes",
  87: "Limousin",
  88: "Lorraine",
  89: "Bourgogne",
  90: "Franche-Comté",
  91: "Île-de-France",
  92: "Île-de-France",
  93: "Île-de-France",
  94: "Île-de-France",
  95: "Île-de-France",
  971: "Guadeloupe",
  972: "Martinique",
  973: "Guyane",
  974: "La-Réunion",
  976: "Mayotte",
};

export default regionByDepartement;
